import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';

const state = {
    briefId: 0,

    id: 0,
    // presupuestoInternoId: 0,
    // presupuestoNumero: '',
    clienteId: 0,
    cliente: null,
    clienteNombre: null,
    accion: '',
    tipoPresupuestoId: 0,
    tipoPresupuesto: null,
    tipoPresupuestoNombre: null,
    canalId: 0,
    canal: null,
    canalNombre: null,
    subcliente: '',
    descripcion: '',
    descripcionAdicionales: '',
    requerimientosDisenio: '',
    formaEntregaEditable: false,
    formaEntregaDigital: false,
    formaEntregaImpresion: false,
    formaEntregaAdaptacion: false,
    formaEntregaIndefinida: false,
    formaEntregaOtros: false,
    formaEntregaOtrosDescripcion: '',
    fechaEntregaMuestra: '1900-01-01',
    fechaEntregaMuestraHabilitada: false,
    fechaEntregaOriginales: '1900-01-01',
    fechaEntregaOriginalesHabilitada: false,
    fechaImplementacion: '1900-01-01',
    fechaImplementacionHabilitada: false,
    especificacionesProduccion: '',
    responsable: '',
    usuario: '',
    rowVersion: null,

    /* Mecanica promocional */
    accionPuntoVenta: false,
    accionConsumidorFinal: false,
    accionFuerzaVenta: false,
    accionOtros: false,
    accionOtrosDescripcion: '',
    titular: '',
    mecanica: '',
    premios: '',
    pieLegal: '',
    piezas: '',

    canales: [],
    imagenes: [],
    links: [],
    marcas: [],
    presupuestosInternos: [],
    tiposDisenios: [],
    tiposPresupuestos: [],
    usuarios: [],
    
    canalesList: [],
    tiposDiseniosList: [],
    tiposPresupuestosList: [],
    usuariosList: [],
    uploadingFiles: false,

    isInicializado: false,
    isDirty: false,
    isDirtySaved: false,
    /* Copias para validar diferencias (isDirty) */
    usuariosBrief: [],
    imagenesBrief: [],
    linksBrief: [],
    marcasBrief: [],
    tiposDiseniosBrief: []
};

const mutations = {
    // updateField,

    updateField(state, field) {
        updateField(state, field);

        state.isDirty = true;
        // console.log(field);
    },

    'INICIALIZAR'(state, briefId) {
        let fechaActual = moment(new Date()).format('YYYY-MM-DD hh:mm');

        state.id = parseInt(briefId);
        // state.presupuestoInternoId = 0;
        // state.presupuestoNumero = '';
        state.clienteId = 0;
        state.cliente = null;
        state.clienteNombre = null;
        state.accion = '';
        state.tipoPresupuestoId = 0;
        state.tipoPresupuesto = null;
        state.tipoPresupuestoNombre = null;
        state.canalId = 0;
        state.canal = null;
        state.canalNombre = null;
        state.subcliente = '';
        state.descripcion = '';
        state.descripcionAdicionales = '';
        state.requerimientosDisenio = '';
        state.formaEntregaEditable = false;
        state.formaEntregaDigital = false;
        state.formaEntregaImpresion = false;
        state.formaEntregaAdaptacion = false;
        state.formaEntregaIndefinida = false;
        state.formaEntregaOtros = false;
        state.formaEntregaOtrosDescripcion = '';
        state.fechaEntregaMuestra = fechaActual;
        state.fechaEntregaMuestraHabilitada = false;
        state.fechaEntregaOriginales = fechaActual;
        state.fechaEntregaOriginalesHabilitada = false;
        state.fechaImplementacion = fechaActual;
        state.fechaImplementacionHabilitada = false;
        state.especificacionesProduccion = '';
        state.responsable = '';
        state.usuario = '';
        state.rowVersion = null;

        /* Mecánica promocional */
        state.accionPuntoVenta = false;
        state.accionConsumidorFinal = false;
        state.accionFuerzaVenta = false;
        state.accionOtros = false;
        state.accionOtrosDescripcion = '';
        state.titular = '';
        state.mecanica = '';
        state.premios = '';
        state.pieLegal = '';
        state.piezas = '';

        state.imagenes = [];
        state.links = [];
        state.marcas = [];
        state.presupuestosInternos = [];
        state.tiposDisenios = [];
        state.usuarios = [];

        state.isInicializado = false;
        state.isDirty = false;
        state.isDirtySaved = false;
        state.usuariosBrief = [];
        state.linksBrief = [];
        state.marcasBrief = [];
        state.muestrasBrief = [];
        state.originalesBrief = [];
        state.tiposDiseniosBrief = [];
    },
    'SET_USUARIOS' (state, usuarios) {
        state.usuariosList = usuarios.map(usuario => ({
            usuarioId: usuario.id,
            usuario: usuario.nombreCompleto.trim(),
            usuarioRolId: usuario.usuarioRolId,
            usuarioRol: usuario.usuarioRol,
            inactivo: usuario.inactivo
        })).sort(function(a, b){
            let x = a.usuarioRol.toLowerCase().trim() + ' ' + a.usuario.toLowerCase().trim();
            let y = b.usuarioRol.toLowerCase().trim() + ' ' + b.usuario.toLowerCase().trim();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });

        state.usuarios = state.usuariosList.map(usuario => ({
            ...usuario,
            asignado: false,
            _rowVariant: ''
        }));
    },
    'SET_CURRENT_USUARIO'(state, usuarioId) {
        let currentUsuario = state.usuarios.find(t => t.usuarioId == usuarioId);
        
        if (currentUsuario) {
            currentUsuario.asignado = true;

            /* Ordenamos la lista de usuarios */
            state.usuarios = state.usuarios.sort(function(a, b){
                /* Ordenamos por condición de inactivo */
                if (!a.inactivo & b.inactivo) {
                    return -1;
                }
                if (a.inactivo & !b.inactivo) {
                    return 1;    
                }
                /* Ordenamos por estado de Asignado */
                if (a.asignado & !b.asignado) {
                    return -1;
                }
                if (!a.asignado & b.asignado) {
                    return 1;    
                }
                /* Ordenamos por Rol y Nombre */
                let x = a.usuarioRol.toLowerCase().trim() + ' ' + a.usuario.toLowerCase().trim();
                let y = b.usuarioRol.toLowerCase().trim() + ' ' + b.usuario.toLowerCase().trim();
                if (x < y) { 
                    return -1; 
                }
                if (x > y) {
                    return 1;
                }
                return 0;
            });
        }
    },
    'SET_CANALES' (state, canales) {
        state.canales = canales;

        state.canalesList = state.canales.map(canal => canal.nombre.trim());
    },
    'SET_TIPOS_PRESUPUESTOS' (state, tiposPresupuestos) {
        state.tiposPresupuestos = tiposPresupuestos;

        state.tiposPresupuestosList = state.tiposPresupuestos.map(item => item.nombre.trim());
    },
    'SET_MARCAS' (state, marcas) {
        state.marcas = marcas.map(marca => ({
            ...marca,
            marcaId: marca.id,
            marca: marca.nombre.trim(),
            inactivo: marca.inactivo,
            rowVersion: marca.rowVersion,
            seleccionado: false,
        })).sort(function(a, b){
            if (a.seleccionado !== b.seleccionado) {
                return a.seleccionado ? -1 : 1;
            }
            if (a.inactivo !== b.inactivo) {
                return a.inactivo ? 1 : -1;
            }
            return a.marca.toLowerCase().localeCompare(b.marca.toLowerCase());
        });        
    },
    'ADD_MARCA' (state, marca) {
        /* Agregamos la marca */
        state.marcas.push({
            marcaId: marca.id,
            marca: marca.nombre.trim(),
            inactivo: false,
            rowVersion: marca.rowVersion,
            seleccionado: false,
        });

        /* Reordenamos la lista */
        state.marcas = state.marcas.sort(function(a, b){
            if (a.seleccionado !== b.seleccionado) {
                return a.seleccionado ? -1 : 1;
            }
            if (a.inactivo !== b.inactivo) {
                return a.inactivo ? 1 : -1;
            }
            return a.marca.toLowerCase().localeCompare(b.marca.toLowerCase());
        });
    },
    'UPDATE_MARCA' (state, marca) {
        let listed = state.marcas.find(t => t.marcaId == marca.id);

        if (listed != null)
        {
            /* Actualizamos los datos de la marca */
            listed.marca = marca.nombre.trim();
            listed.inactivo = (/true/i).test(marca.inactivo);
            listed.rowVersion = marca.rowVersion;

            /* Si se inactivó la marca y no está seleccionada, la eliminamos de la lista */
            if ((/true/i).test(marca.inactivo)) {
                if (!(/true/i).test(listed.seleccionado)) {
                    let itemKey = state.marcas
                        .findIndex(t => t.marcaId == marca.id);
                    
                    if (itemKey != -1) {
                        state.marcas.splice(itemKey, 1);
                    }
                }
            }
        }

        /* Reordenamos la lista */
        state.marcas = state.marcas.sort((a, b) => {
            if (a.seleccionado !== b.seleccionado) {
                return a.seleccionado ? -1 : 1;
            }
            if (a.inactivo !== b.inactivo) {
                return a.inactivo ? 1 : -1;
            }
            return a.marca.toLowerCase().localeCompare(b.marca.toLowerCase());
        });
    },
    'SET_TIPOS_DISENIOS' (state, tiposDisenios) {
        state.tiposDiseniosList = tiposDisenios.map(tipoDisenio => ({
            tipoDisenioId: tipoDisenio.id,
            tipoDisenio: tipoDisenio.nombre.trim(),
            mecanicaPromocional: (/true/i).test(tipoDisenio.mecanicaPromocional)
        })).sort(function(a, b){
            let x = a.tipoDisenio.toLowerCase().trim();
            let y = b.tipoDisenio.toLowerCase().trim();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });

        state.tiposDisenios = state.tiposDiseniosList.map(tipoDisenio => ({
            ...tipoDisenio,
            seleccionado: false,
            _rowVariant: ''
        }));
    },
    'SET_BRIEF'(state, brief) {
        let fechaActual = moment(new Date()).format('YYYY-MM-DD HH:mm');

        // state.presupuestoInternoId = brief.presupuestoInternoId;
        // state.presupuestoNumero = brief.presupuestoNumero;
        state.clienteId = brief.clienteId;
        state.cliente = brief.cliente;
        state.clienteNombre = brief.cliente? brief.cliente.nombre.trim() : null;
        state.accion = brief.accion;
        state.tipoPresupuestoId = brief.tipoPresupuestoId;
        state.tipoPresupuesto = brief.tipoPresupuesto;
        state.tipoPresupuestoNombre = brief.tipoPresupuesto? brief.tipoPresupuesto.nombre.trim() : null;
        state.canalId = brief.canalId;
        state.canal = brief.canal;
        state.canalNombre = brief.canal? brief.canal.nombre.trim() : null;
        state.subcliente = brief.subcliente;
        state.descripcion = brief.descripcion;
        state.descripcionAdicionales = brief.descripcionAdicionales;
        state.requerimientosDisenio = brief.requerimientosDisenio;
        state.formaEntregaEditable = (/true/i).test(brief.formaEntregaEditable);
        state.formaEntregaDigital = (/true/i).test(brief.formaEntregaDigital);
        state.formaEntregaImpresion = (/true/i).test(brief.formaEntregaImpresion);
        state.formaEntregaAdaptacion = (/true/i).test(brief.formaEntregaAdaptacion);
        state.formaEntregaIndefinida = (/true/i).test(brief.formaEntregaIndefinida);
        state.formaEntregaOtros = (/true/i).test(brief.formaEntregaOtros);
        state.formaEntregaOtrosDescripcion = brief.formaEntregaOtrosDescripcion;
        state.fechaEntregaMuestra = moment(brief.fechaEntregaMuestra).format('YYYY-MM-DD HH:mm');
        if (moment(brief.fechaEntregaMuestra).format('YYYY-MM-DD') != '1900-01-01') {
            state.fechaEntregaMuestraHabilitada = true;
        } else {
            state.fechaEntregaMuestra = fechaActual;
            state.fechaEntregaMuestraHabilitada = false;   
        }
        state.fechaEntregaOriginales = moment(brief.fechaEntregaOriginales).format('YYYY-MM-DD HH:mm');
        if (moment(brief.fechaEntregaOriginales).format('YYYY-MM-DD') != '1900-01-01') {
            state.fechaEntregaOriginalesHabilitada = true;
        } else {
            state.fechaEntregaOriginales = fechaActual;
            state.fechaEntregaOriginalesHabilitada = false;   
        }
        state.fechaImplementacion = moment(brief.fechaImplementacion).format('YYYY-MM-DD HH:mm');
        if (moment(brief.fechaImplementacion).format('YYYY-MM-DD') != '1900-01-01') {
            state.fechaImplementacionHabilitada = true;
        } else {
            state.fechaImplementacion = fechaActual;
            state.fechaImplementacionHabilitada = false;   
        }
        state.especificacionesProduccion = brief.especificacionesProduccion;
        state.responsable = brief.responsable;
        state.usuario = brief.usuario;
        state.rowVersion = brief.rowVersion;

        /* Mecánica promocional */
        state.accionPuntoVenta = (/true/i).test(brief.accionPuntoVenta);
        state.accionConsumidorFinal = (/true/i).test(brief.accionConsumidorFinal);
        state.accionFuerzaVenta = (/true/i).test(brief.accionFuerzaVenta);
        state.accionOtros = (/true/i).test(brief.accionOtros);
        state.accionOtrosDescripcion = brief.accionOtrosDescripcion;
        state.titular = brief.titular;
        state.mecanica = brief.mecanica;
        state.premios = brief.premios;
        state.pieLegal = brief.pieLegal;
        state.piezas = brief.piezas;

        state.imagenes = brief.imagenes.map(imagen => ({
            id: helpers.methods.getUUID(),
            imagenId: imagen.id,
            publicId: imagen.publicId,
            fileName: imagen.fileName,
            url: imagen.url
        }))

        if (state.canalId != 0) {
            var canal = state.canales.find(t => t.id == state.canalId);
            if (!canal) {
                state.canales.push({
                    id: state.canalId,
                    nombre: state.canal.nombre.trim()
                });

                state.canalesList.push(state.canal.nombre.trim());
            }
        }

        state.links = brief.links.map(item => ({
            id: helpers.methods.getUUID(),
            linkId: item.id,
            link: item.link,
            descripcion: item.descripcion,
        }))

        if (brief.marcas) {
            brief.marcas.forEach(marca => {
                let selected = state.marcas.find(t => t.marcaId == marca.marcaId);
                if (selected) {
                    selected.seleccionado = true;
                } else {
                    /* Agregamos la marca (inactiva) */
                    state.marcas.push({
                        marcaId: marca.marcaId,
                        marca: marca.marca.trim(),
                        inactivo: (/true/i).test(marca.inactivo),
                        seleccionado: true,
                        rowVersion: marca.rowVersion
                    })
                }
            });
        }

        /* Ordenamos la lista de marcas */
        state.marcas = state.marcas.sort(function(a, b){
            if (a.seleccionado !== b.seleccionado) {
                return a.seleccionado ? -1 : 1;
            }
            if (a.inactivo !== b.inactivo) {
                return a.inactivo ? 1 : -1;
            }
            return a.marca.toLowerCase().localeCompare(b.marca.toLowerCase());
        });

        state.presupuestosInternos = brief.presupuestosInternos.sort(function(a, b){
            if (a.presupuestoNumero < b.presupuestoNumero) {
                return -1;
            }
            if (a.presupuestoNumero > b.presupuestoNumero) {
                return 1;
            }
            return 0;
        });

        state.tiposDisenios = state.tiposDiseniosList.map(tipoDisenio => ({
            ...tipoDisenio,
            seleccionado: false,
            _rowVariant: ''
        }));

        if (brief.tiposDisenios) {
            brief.tiposDisenios.forEach(tipoDisenio => {
                let selected = state.tiposDisenios.find(t => t.tipoDisenioId == tipoDisenio.tipoDisenioId);
                if (selected) {
                    selected.seleccionado = true;
                } else {
                    /* Agregamos el tipo de diseño (inactivo) */
                    state.tiposDisenios.push({
                        tipoDisenioId: tipoDisenio.tipoDisenioId,
                        tipoDisenio: tipoDisenio.tipoDisenio.trim(),
                        inactivo: tipoDisenio.inactivo,
                        seleccionado: true,
                        _rowVariant: tipoDisenio.inactivo? 'inactivo' : ''
                    })
                }
            });
        }

        /* Ordenamos la lista de tipos de diseño */
        state.tiposDisenios = state.tiposDisenios.sort(function(a, b){
            /* Ordenamos por condición de inactivo */
            if (!a.inactivo & b.inactivo) {
                return -1;
            }
            if (a.inactivo & !b.inactivo) {
                return 1;    
            }
            /* Ordenamos por estado Seleccionado */
            if (a.seleccionado & !b.seleccionado) {
                return -1;
            }
            if (!a.seleccionado & b.seleccionado) {
                return 1;    
            }
            /* Ordenamos por Nombre */
            let x = a.tipoDisenio.toLowerCase().trim();
            let y = b.tipoDisenio.toLowerCase().trim();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });

        if (state.tipoPresupuestoId != 0) {
            var tipoPresupuesto = state.tiposPresupuestos.find(t => t.id == state.tipoPresupuestoId);
            if (!tipoPresupuesto) {
                state.tiposPresupuestos.push({
                    id: state.tipoPresupuestoId,
                    nombre: state.tipoPresupuestoNombre.trim()
                });

                state.tiposPresupuestosList.push(state.tipoPresupuestoNombre.trim());
            }
        }

        state.usuarios = state.usuariosList.map(usuario => ({
            ...usuario,
            asignado: false,
            _rowVariant: ''
        }));

        if (brief.usuarios) {
            brief.usuarios.forEach(usuario => {
                let selected = state.usuarios.find(t => t.usuarioId == usuario.usuarioId);
                if (selected) {
                    selected.asignado = true;
                } else {
                    /* Agregamos el usuario (inactivo) */
                    state.usuarios.push({
                        usuarioId: usuario.usuarioId,
                        usuario: usuario.usuario.trim(),
                        usuarioRolId: usuario.usuarioRolId,
                        usuarioRol: usuario.usuarioRol,
                        inactivo: usuario.inactivo,
                        asignado: true,
                        _rowVariant: usuario.inactivo? 'inactivo' : ''
                    })
                }
            });
        }

        /* Ordenamos la lista de usuarios */
        state.usuarios = state.usuarios.sort(function(a, b){
            /* Ordenamos por condición de inactivo */
            if (!a.inactivo & b.inactivo) {
                return -1;
            }
            if (a.inactivo & !b.inactivo) {
                return 1;    
            }
            /* Ordenamos por estado de Asignado */
            if (a.asignado & !b.asignado) {
                return -1;
            }
            if (!a.asignado & b.asignado) {
                return 1;    
            }
            /* Ordenamos por Rol y Nombre */
            let x = a.usuarioRol.toLowerCase().trim() + ' ' + a.usuario.toLowerCase().trim();
            let y = b.usuarioRol.toLowerCase().trim() + ' ' + b.usuario.toLowerCase().trim();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });

        state.isInicializado = true;
        state.isDirty = false;
        state.isDirtySaved = false;
        state.usuariosBrief = cloneDeep(state.usuarios);
        state.imagenesBrief = cloneDeep(state.imagenes);
        state.linksBrief = cloneDeep(state.links);
        state.marcasBrief = cloneDeep(state.marcas);
        state.tiposDiseniosBrief = cloneDeep(state.tiposDisenios);
    },
    'SET_CLIENTE' (state, cliente) {
        state.cliente = cliente;
        if (cliente) {
            state.clienteId = cliente.id? cliente.id : 0;
            state.clienteNombre = cliente.nombre? cliente.nombre.trim() : null;
        } else {
            state.clienteId = 0;
            state.clienteNombre = null;
        }
        
        /* Reinicializamos las marcas del cliente */
        state.marcas = [];

        state.isDirty = true;
    },
    'SET_TIPO_PRESUPUESTO' (state, tipoPresupuesto) {
        state.tipoPresupuesto = tipoPresupuesto;
        if (tipoPresupuesto) {
            state.tipoPresupuestoId = tipoPresupuesto.id? tipoPresupuesto.id : 0;
            state.tipoPresupuestoNombre = tipoPresupuesto.nombre? tipoPresupuesto.nombre.trim() : null;
        } else {
            state.tipoPresupuestoId = 0;
            state.tipoPresupuestoNombre = null;
        }
        state.isDirty = true;
    },
    'SET_CANAL' (state, canal) {
        state.canal = canal;
        if (canal) {
            state.canalId = canal.id? canal.id : 0;
            state.canalNombre = canal.nombre? canal.nombre.trim() : null;
        } else {
            state.canalId = 0;
            state.canalNombre = null;
        }
        state.isDirty = true;
    },
    'SET_UPLOADING'(state) {
        state.uploadingFiles = true;
    },
    'SET_IMAGEN'(state, params) {
        state.imagenes.push({
            id: helpers.methods.getUUID(),
            imagenId: 0,
            publicId: params.publicId,
            fileName: params.fileName,
            url: params.url
        });

        state.uploadingFiles = false;
    },
    'DELETE_IMAGEN'(state, imagenId) {
        let itemKey = state.imagenes
            .findIndex(imagen => imagen.id == imagenId);

        if (itemKey != -1) {
            state.imagenes.splice(itemKey, 1);
        }
    },
    'ADD_LINK'(state, item) {
        state.links.push({
            id: helpers.methods.getUUID(),
            linkId: 0,
            link: item.link,
            descripcion: item.descripcion
        });
    },
    'DELETE_LINK'(state, linkId) {
        let itemKey = state.links
            .findIndex(link => link.id == linkId);

        if (itemKey != -1) {
            state.links.splice(itemKey, 1);
        }
    },
    'ADD_PRESUPUESTO_INTERNO'(state, presupuestoInterno) {
        console.log(state.presupuestosInternos)

        let itemKey = state.presupuestosInternos
            .findIndex(t => t.presupuestoInternoId == presupuestoInterno.id);

        if (itemKey == -1) {
            console.log(presupuestoInterno)
            state.presupuestosInternos.push({
                presupuestoInternoId: presupuestoInterno.id,
                presupuestoNumero: presupuestoInterno.numero,
                accion: presupuestoInterno.accion
            })
            
            console.log(state.presupuestosInternos)

            state.presupuestosInternos = state.presupuestosInternos.sort(function(a, b){
                if (a.presupuestoNumero < b.presupuestoNumero) {
                    return -1;
                }
                if (a.presupuestoNumero > b.presupuestoNumero) {
                    return 1;
                }
                return 0;
            });
        }
    },
    'DELETE_PRESUPUESTO_INTERNO'(state, presupuestoInternoId) {
        let itemKey = state.presupuestosInternos
            .findIndex(t => t.presupuestoInternoId == presupuestoInternoId);

        if (itemKey != -1) {
            state.presupuestosInternos.splice(itemKey, 1);
        }
    },
    'SET_CLEAN'(state) {
        state.isDirty = false;
    },
    'SET_DIRTY'(state) {
        state.isDirty = true;
    },
    'UPDATE_BRIEF'(state, params) {
        state.id = params.id;
        state.rowVersion = params.rowVersion;

        /* Reinicializamos el estado */
        state.isDirtySaved = state.isDirty;
        state.isDirty = false;

        state.imagenesBrief = cloneDeep(state.imagenes);
        state.marcasBrief = cloneDeep(state.marcas);
        state.tiposDiseniosBrief = cloneDeep(state.tiposDisenios);
    },
    'SET_BRIEF_ID'(state, briefId) {
        state.briefId = briefId;
    },
};

const getters = {
    getField,

    dirty(state) {
        if ((/true/i).test(state.isDirty)) {
            return true;
        }

        if(!isEqual(state.imagenes, state.imagenesBrief)) {
            return true;
        }

        if(!isEqual(state.links, state.linksBrief)) {
            return true;
        }

        if(!isEqual(state.marcas, state.marcasBrief)) {
            return true;
        }

        if(!isEqual(state.tiposDisenios, state.tiposDiseniosBrief)) {
            return true;
        }

        return false;
    },
    briefId(state) {
        return state.briefId;
    }
};

const actions = {
    async inicializar ( { commit, rootState }, briefId ) {
        commit('INICIALIZAR', briefId);

        const getBrief = !!briefId && briefId !== 0;

        try
        {
            const resUsuarios = await apiAxios.get('usuarios/asignar-brief');
            commit('SET_USUARIOS', resUsuarios.data);

            const resCanales = await apiAxios.get('canales/list');
            commit('SET_CANALES', resCanales.data);

            const resTiposPresupuestos = await apiAxios.get('tipos-presupuestos/list');
            commit('SET_TIPOS_PRESUPUESTOS', resTiposPresupuestos.data);

            const resTiposDisenios = await apiAxios.get('tipos-disenios/list');
            commit('SET_TIPOS_DISENIOS', resTiposDisenios.data);

            if (getBrief) {
                
                const resMarcas = await apiAxios.get(`marcas/brief/${briefId}`);
                commit('SET_MARCAS', resMarcas.data);

                const resBrief = await apiAxios.get(`briefs/${briefId}/abm`);
                commit('SET_BRIEF', resBrief.data);

            } else {

                commit('SET_CURRENT_USUARIO', rootState.user.userId);

            }
        }
        catch(error) {
            throw error;
        }
    },    

    async save ( { state, commit } ) {
        try {
            let imagenes = [];
            if (state.imagenes) {
                imagenes = state.imagenes.map(imagen => ({
                    id: imagen.imagenId,
                    publicId: imagen.publicId,
                    fileName: imagen.fileName,
                    url: imagen.url
                }))
            }

            let links = [];
            if (state.links) {
                links = state.links.map(item => ({
                    id: item.linkId,
                    link: item.link,
                    descripcion: item.descripcion
                }))
            }

            let presupuestosInternos = [];
            if (state.presupuestosInternos) {
                presupuestosInternos = state.presupuestosInternos.map(item => ({
                    presupuestoInternoId: item.presupuestoInternoId
                }))
            }

            let brief = {
                clienteId: state.clienteId,
                accion: state.accion.toUpperCase().trim(),
                tipoPresupuestoId: state.tipoPresupuestoId,
                canalId: state.canalId,
                subcliente: state.subcliente.toUpperCase().trim(),
                descripcion: state.descripcion.trim(),
                descripcionAdicionales: state.descripcionAdicionales.trim(),
                requerimientosDisenio: state.requerimientosDisenio.trim(),
                formaEntregaEditable: (/true/i).test(state.formaEntregaEditable),
                formaEntregaDigital: (/true/i).test(state.formaEntregaDigital),
                formaEntregaImpresion: (/true/i).test(state.formaEntregaImpresion),
                formaEntregaAdaptacion: (/true/i).test(state.formaEntregaAdaptacion),
                formaEntregaIndefinida: (/true/i).test(state.formaEntregaIndefinida),
                formaEntregaOtros: (/true/i).test(state.formaEntregaOtros),
                formaEntregaOtrosDescripcion: state.formaEntregaOtrosDescripcion.trim(),
                
                fechaEntregaMuestra: helpers.methods.getConditionalDateTime(state.fechaEntregaMuestraHabilitada, state.fechaEntregaMuestra),
                fechaEntregaOriginales: helpers.methods.getConditionalDateTime(state.fechaEntregaOriginalesHabilitada, state.fechaEntregaOriginales),
                fechaImplementacion: helpers.methods.getConditionalDateTime(state.fechaImplementacionHabilitada, state.fechaImplementacion),

                especificacionesProduccion: state.especificacionesProduccion.trim(),

                accionPuntoVenta: (/true/i).test(state.accionPuntoVenta),
                accionConsumidorFinal: (/true/i).test(state.accionConsumidorFinal),
                accionFuerzaVenta: (/true/i).test(state.accionFuerzaVenta),
                accionOtros: (/true/i).test(state.accionOtros),
                accionOtrosDescripcion: state.accionOtrosDescripcion.trim(),
                titular: state.titular.trim(),
                mecanica: state.mecanica.trim(),
                premios: state.premios.trim(),
                pieLegal: state.pieLegal.trim(),
                piezas: state.piezas.trim(),

                imagenes,
                links,
                presupuestosInternos
            }
            
            brief.usuarios = state.usuarios
                .filter(t => t.asignado)
                .map(t => ({
                    usuarioId: t.usuarioId,
                    usuarioRolId: t.usuarioRolId
                }));

            brief.marcas = state.marcas
                .filter(t => t.seleccionado)
                .map(t => ({
                    marcaId: t.marcaId,
                }));

            brief.tiposDisenios = state.tiposDisenios
                .filter(t => t.seleccionado)
                .map(t => ({
                    tipoDisenioId: t.tipoDisenioId,
                }));
            
            let url = 'briefs';
            if (state.id) {
                if (state.id != 0) {
                    url += `/${state.id}`;
                    brief.rowVersion = state.rowVersion;
                }
            }

            const res = await apiAxios.post(url, brief);
            commit("UPDATE_BRIEF", res.data);

        } catch(error) {
            const errorMessage = helpers.methods.getErrorMessage(error);
            throw new Error(errorMessage);
        }
    },
    setCliente ( { commit, state }, cliente) {
        return new Promise((resolve, reject) => {
            commit('SET_CLIENTE', cliente);

            if (state.clienteId != 0) {
                apiAxios.get(`marcas/clientes/${state.clienteId}`)
                    .then(res => {
                        commit('SET_MARCAS', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve;
            }
        })
    },
    setTipoPresupuesto ( { commit }, tipoPresupuesto) {
        return new Promise((resolve, reject) => {
            commit('SET_TIPO_PRESUPUESTO', tipoPresupuesto);
            resolve();
        })
    },
    setCanal ( { commit }, canal) {
        return new Promise((resolve, reject) => {
            commit('SET_CANAL', canal);
            resolve();
        })
    },
    uploadImagen ( { commit }, file ) {
        return new Promise((resolve, reject) => {
            let upload = true;
            let errorMessage = '';

            /* Validamos los archivos a subir */
            let fileName = file.name;
            let fileExtension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
            let fileSize = parseFloat(file.size / 1048576);

            if (fileExtension != 'jpg' 
                && fileExtension != 'png'
                && fileExtension != 'jpeg'
                && fileExtension != 'pdf'
                && fileExtension != 'ppt'
                && fileExtension != 'pptx'
                && fileExtension != 'doc'
                && fileExtension != 'docx'
                && fileExtension != 'xls'
                && fileExtension != 'xlsx'
                && fileExtension != 'zip'
                && fileExtension != 'rar'
                && fileExtension != 'ai'
                && fileExtension != 'psd') {
                    upload = false;
                    errorMessage = 'El tipo de archivo seleccionado no es válido.';
            }

            if (fileSize >= 10 ) {
                upload = false;
                errorMessage = 'El archivo seleccionado tiene un peso mayor al permitido. Sólo se permiten imágenes o documentos de hasta 10MB.';
            }

            if (upload) {
                commit('SET_UPLOADING');
    
                let formData = new FormData();
                formData.append('file', file);
                
                let options = {
                    headers: { 'Content-Type': 'multipart/form-data' },
                }
                apiAxios.post(`briefs/${state.id}/imagenes`, formData, options)
                    .then(res => {
                        commit('SET_IMAGEN', {
                            publicId: res.data.publicId,
                            fileName: res.data.fileName,
                            url: res.data.url
                        });
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    sendNotificacionesCambios ({}) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`briefs/${state.id}/send-notificaciones`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    deleteImagen ( { commit }, imagenId) {
        return new Promise((resolve, reject) => {
            commit('DELETE_IMAGEN', imagenId);
            resolve();
        })
    },
    addLink ( { commit }, link) {
        return new Promise((resolve, reject) => {
            commit('ADD_LINK', link);
            resolve();
        })
    },
    deleteLink ( { commit }, linkId) {
        return new Promise((resolve, reject) => {
            commit('DELETE_LINK', linkId);
            resolve();
        })
    },
    addPresupuestoInterno ( { commit }, presupuestoInterno) {
        return new Promise((resolve, reject) => {
            commit('ADD_PRESUPUESTO_INTERNO', presupuestoInterno);
            resolve();
        })
    },
    deletePresupuestoInterno ( { commit }, presupuestoInternoId) {
        return new Promise((resolve, reject) => {
            commit('DELETE_PRESUPUESTO_INTERNO', presupuestoInternoId);
            resolve();
        })
    },
    cancel ( { state } ) {
        return new Promise((resolve, reject) => {
            let promises = [];

            /* Verifico si hay imagenes pendientes y las cancelo */
            state.imagenes
                .filter(t => t.imagenId == 0 && t.publicId != '')
                .forEach(imagen => {
                    let file = {
                        publicId: imagen.publicId
                    }
                    promises.push(apiAxios.post(`briefs/${state.id}/imagenes/delete`, file));
                });

            if (promises.length != 0) {
                Promise.all(promises)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    setClean ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('SET_CLEAN');
            resolve();
        })
    },
    setDirty ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('SET_DIRTY');
            resolve();
        })
    },
    addMarca( { commit }, marca ) {
        return new Promise((resolve, reject) => {
            commit('ADD_MARCA', marca);
            resolve();
        })
    },
    updateMarca( { commit }, marca ) {
        return new Promise((resolve, reject) => {
            commit('UPDATE_MARCA', marca);
            resolve();
        })
    },
    addBriefByPresupuesto ( { commit }, presupuestoInternoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`briefs/presupuestos/${presupuestoInternoId}`)
                .then(res => {
                    commit('SET_BRIEF_ID', res.data.id);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    asociarPresupuesto ( {}, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`briefs/${params.briefId}/presupuestos/${params.presupuestoInternoId}/asociar`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },        
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}